
export const projects = [ 
    {
      title: "Tic-Tac-Toe",
      subtitle: "Javascript",
      description:
        "Tic-Tac-Toe game implemented by using general Html, CSS , JavaScript ",
      image:"game1.png",
      link: "https://pragati1317.github.io/Tic-Tac-Toegame/",
    }, 
    {
      title: "Agritech",
      subtitle: "Php with javascript",
      description:
        "Agri-tech is the Agriculture Informative website, basically it Provides the information to farmers related to Government-Policy/Scheme, Options to Buy and Sells the Product, Vendors can also Updated the Crop Rate-list.",
      image:"Agritech.png",
      link: "https://github.com/pragati1317/Minor_Project",
    },
    {
      title: "Todo list",
      subtitle: "Manage task list",
      description:
        "It is a Todo list implement by using Html , CSS ,JavaScript and javascript local storage ",
      image:"ToDo.png",
      link: " https://pragati1317.github.io/MyToDo_list/",
    },
    { title:"Bookify",
      subtitle: "Book Recommender System on user preferences", 
      description: "Developed a web application using Flask that provides users with a curated list of 50 popular books and recommends similar books based on user input.The recommendation engine leverages data science and data analytics technologies to enhance user experience ",
      image:"BookRecommender.png",
      link: "https://github.com/pragati1317/Book_RecommenderSystem/",
    },
    {
      title: "Resturant menu",
      subtitle: "Resturant menu card",
      description:
        "It is Resturant menu card , customer can access all items of resturant",
      image:"Menu.png",
      link: "https://pragati1317.github.io/Resturant_menu/Resturent_menu/",
    },
  ]
